export const siteConfig = {
  name: '开运 com',
  tagline: '专业开运风水与好运提升平台',
  description: '开运 com 是您一站式开运解决方案平台，汇聚风水布局、开运饰品、命理测算、幸运色搭配等专业内容，帮助您提升财运、桃花运与事业运，让好运从此与您同行。',
  url: 'https://kaiyun.com/',
  locale: 'zh-Hans',
  author: '开运 com',
  address: {
    locality: '北京',
    region: '北京',
    country: 'CN',
    full: '北京市朝阳区好运路88号开运大厦',
  },
  contact: {
    phone: '+86-10-8888-6666',
    email: 'hello@kaiyun.com',
    wechat: 'kaiyun_com',
  },
  social: {
    weibo: 'https://weibo.com/kaiyun',
    xiaohongshu: '开运 com',
  },
  geo: {
    position: '39.9042;116.4074',
    region: 'CN-BJ',
    placename: '北京',
  },
};